import { useUpdateDocumentTitle } from '@anytag/shared-hooks';
import { AutoManagedCampaignsList, AutoManagedCampaignsFilter } from '@anytag/shared-organisms';
import { CustomShopeeCampaignsTrigger, Header, ListWithPagination } from '@anytag/shared-molecules';
import { useAutoManagedCampaignsData } from './hooks';

export const AutoManagedCampaigns = () => {
  useUpdateDocumentTitle({
    title: 'documentTitle.Auto Managed Campaign',
    appHeader: 'appHeader.Auto Managed Campaign'
  });
  const { loading, campaigns, totalRecords } = useAutoManagedCampaignsData();

  return (
    <div>
      <Header>
        <CustomShopeeCampaignsTrigger className="ml-auto" />
      </Header>
      <ListWithPagination pagination={{ totalRecords }}>
        <AutoManagedCampaignsFilter />
        <AutoManagedCampaignsList data={campaigns} loading={loading} totalRecords={totalRecords} />
      </ListWithPagination>
    </div>
  );
};
